var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 16,
    viewBox: "0 0 45 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2706 8.90676L0.910959 8.90676C0.407085 8.90676 0 8.49968 0 7.9958C0 7.49193 0.407085 7.08484 0.910959 7.08484L41.07 7.08484L35.5416 1.55646C35.1858 1.20062 35.1858 0.622726 35.5416 0.266883C35.8975 -0.0889608 36.4754 -0.0889608 36.8312 0.266883L43.9168 7.35244C44.1787 7.61434 44.2555 8.00434 44.1132 8.34595C43.9709 8.68471 43.6378 8.90676 43.2706 8.90676Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1759 15.9982C35.9424 15.9982 35.709 15.91 35.5325 15.7306C35.1767 15.3748 35.1767 14.7969 35.5325 14.4411L42.6266 7.34696C42.9824 6.99112 43.5603 6.99112 43.9162 7.34696C44.272 7.7028 44.272 8.2807 43.9162 8.63654L36.8221 15.7306C36.6427 15.91 36.4093 15.9982 36.1759 15.9982Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongNextArrow);
export default __webpack_public_path__ + "static/media/long-next-arrow.481abe375296cb6649479d492d47f22e.svg";
export { ForwardRef as ReactComponent };